import { createFileRoute } from "@tanstack/react-router";

import {
  getInfiniteRentalDealsQueryOptions,
  getRentalDealsServerSorting,
} from "../../../entities/rental-deal/list-query-options";
import { dealsSearchParamsSchema } from "../../../pages/deals-page/types";

export const Route = createFileRoute("/_layout-main/deals/")({
  validateSearch: dealsSearchParamsSchema,
  loaderDeps: ({ search }) => ({
    sorting: search.sorting,
    sortingDir: search.sortingDir,
  }),
  loader: ({ context: { queryClient }, deps: { sorting, sortingDir } }) =>
    queryClient.prefetchInfiniteQuery(
      getInfiniteRentalDealsQueryOptions({
        statusCode: "Active",
        sorting: getRentalDealsServerSorting(sorting, sortingDir),
      }),
    ),
});
